<app-web-loader *ngIf="isLoader"></app-web-loader>
<app-login-modal></app-login-modal>

<div class="main-inner-div">

    <ng-container *ngIf="!isPostEdit">

        <div class="row">
            <div class="col-sm-5">
                <div class="category-div">
                    <div class="form-group">
                        <div><label for="rdbReqWant" style="color: #000; font-weight: 500;"> Do you want to: </label>
                        </div>
                        <div class="category-radio-div">
                            <div class="form-check form-check-inline l-radio">
                                <div class="panel-container" (click)="selectRadio('rdbBuy')">
                                    <input class="form-check-input" (change)="doChangeRequestType(1)" type="radio"
                                        name="rdbReqWant" id="rdbBuy" value="Buy" />
                                    <label class="form-check-label" for="rdbBuy" style="color:#000;">Buy</label>
                                </div>
                            </div>
                            <div class="form-check form-check-inline l-radio">
                                <div class="panel-container" (click)="selectRadio('rdbRent')">
                                    <input class="form-check-input" (change)="doChangeRequestType(2)" type="radio"
                                        name="rdbReqWant" id="rdbRent" value="Rent" />
                                    <label class="form-check-label" for="rdbRent" style="color:#000;">Rent</label>
                                </div>
                            </div>
                            <div class="form-check form-check-inline l-radio">
                                <div class="panel-container" (click)="selectRadio('rdbSale')">
                                    <input class="form-check-input" (change)="doChangeRequestType(3)" type="radio"
                                        name="rdbReqWant" id="rdbSale" value="Sale" checked />
                                    <label class="form-check-label" for="rdbSale" style="color:#000;">Sale</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="category-div">
                    <div class="form-group">
                        <label for="rdbReqFor"
                            style="float: left; margin-right: 5px; width: 100%; color: #000; font-weight: 500;">
                            Request For:
                        </label>
                        <div class="category-radio-div">
                            <div class="form-check form-check-inline l-radio">
                                <div class="panel-container" (click)="selectRadio('rdbReqSelf')">
                                    <input class="form-check-input" (change)="doChangeRequestForType(1)" type="radio"
                                        name="rdbReqFor" id="rdbReqSelf" value="Self" checked />
                                    <label class="form-check-label" for="rdbReqSelf" style="color:#000;">Self</label>
                                </div>
                            </div>
                            <div class="form-check form-check-inline l-radio">
                                <div class="panel-container" (click)="selectRadio('rdbReqOthers')">
                                    <input class="form-check-input" (change)="doChangeRequestForType(2)" type="radio"
                                        name="rdbReqFor" id="rdbReqOthers" value="Others" />
                                    <label class="form-check-label" for="rdbReqOthers"
                                        style="color:#000;">Others</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form [formGroup]="propertyPostForm">
            <div class="form-group" *ngIf="isOtherMobile">
                <label for="otherMobileNo">Other Mobile No:</label>
                <div class="input-container">
                    <input type="text" id="otherMobileNo" [ngClass]="{
                        'form-control': true,
                        'is-invalid': propertyPostForm.controls['otherMobileNo'].invalid && propertyPostForm.controls['otherMobileNo'].touched,
                        'is-valid': propertyPostForm.controls['otherMobileNo'].valid
                    }" formControlName="otherMobileNo" autocomplete="off" maxlength="10" />
                    <span *ngIf="propertyPostForm.controls['otherMobileNo'].valid" class="icon-success">
                        <i class="fas fa-check"></i>
                    </span>
                    <span *ngIf="!propertyPostForm.controls['otherMobileNo'].valid" class="icon-danger">
                        <i class="fas fa-exclamation-triangle"></i>
                    </span>
                </div>
            </div>
        </form>
        <br />

        <label class="form-check-label pad10B" for="rdbProptype" style="color: #000;font-weight: 500;">Property
            Type</label>
        <div class="category-type-div">
            <ul>
                <li>
                    <input class="rdbcategory-type" type="radio" name="select" id="option-1"
                        [checked]="postDetails?.PropertyTypeName === 'Residential'"
                        (change)="onPropertyTypeChange('Residential')" />
                    <label for="option-1" class="option option-1"><span>Residential</span></label>
                </li>
                <li>
                    <input class="rdbcategory-type" type="radio" name="select" id="option-2"
                        [checked]="postDetails?.PropertyTypeName === 'Commercial'"
                        (change)="onPropertyTypeChange('Commercial')" />
                    <label for="option-2" class="option option-2"><span>Commercial</span></label>
                </li>
                <li>
                    <input class="rdbcategory-type" type="radio" name="select" id="option-3"
                        [checked]="postDetails?.PropertyTypeName === 'Land'" (change)="onPropertyTypeChange('Land')" />
                    <label for="option-3" class="option option-3"><span>Land</span></label>
                </li>


            </ul>
        </div>

        <div class="category-sub-type-div">
            <p *ngFor="let sub of propertySubListById  || []" (click)="doSelectSubProperty(sub)"
                [ngClass]="postRequest.selectedSubProdID == sub.PropertySubTypeID ? 'text-green': 'text-black'">
                {{ sub.PropertySubTypeName }}
            </p>
        </div>

    </ng-container>

    <ng-container *ngIf="isPostEdit">
        <div style="border: 1px solid #ddd; padding: 10px; border-radius: 5px;">
            <div class="category-div" style="display: flex; flex-wrap: wrap;">
                <div class="form-group" style="flex: 1; margin-bottom: 0;">
                    <label for="rdbReqWant" style="width: 100%; color: #000;">
                        Requested to: <br>
                        <strong>{{ postDetails?.Req_Type }}</strong>
                    </label>
                </div>
                <div class="form-group" style="flex: 1; margin-bottom: 0;">
                    <label for="rdbReqWant" style="width: 100%; color: #000;">
                        Request For: <br>
                        <strong>{{ postDetails?.Proprty_For }}</strong>
                    </label>
                </div>
            </div>
            <div class="category-div" style="display: flex; flex-wrap: wrap;">
                <div class="form-group" style="flex: 1; margin-bottom: 0;">
                    <label for="rdbReqWant" style="width: 100%; color: #000;">
                        Property Type: <br>
                        <strong>{{ postDetails?.PropertyTypeName }}</strong>
                    </label>
                </div>
                <div class="form-group" style="flex: 1; margin-bottom: 0;">
                    <label for="rdbReqWant" style="width: 100%; color: #000;">
                        Property Sub Type: <br>
                        <strong>{{ postDetails?.PropertySubTypeName }}</strong>
                    </label>
                </div>
            </div>

            <div class="Your-Preffered-Location">
                <div class="form-group">
                    <label style="color: #000; font-weight: 500;">Your Preferred Location</label>
                    <div class="form-control">
                        <span class="badge badge-dark" style="margin-right: 5px;"
                            *ngFor="let area of postRequest.selectedAreasID || []">{{ area }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="clearfix mrg15B"></div>

    <!-- Replace the existing Preferred Location sections with this improved version -->

    <div class="elevate_cls">
        <div class="row">
            <div class="col-md-6" *ngIf="![17, 19, 20, 21, 22, 23].includes(+postRequest.selectedSubProdID)">
                <div class="pad10T right_arrow" *ngIf="!isPostEdit">
                    <div class="form-check form-check-inline l-radio left">
                        <div class="panel-container" (click)="selectRadio('rdbVentureInd')">
                            <input class="form-check-input" (change)="doChangeVenture(0)" checked type="radio"
                                name="rdbVenture" id="rdbVentureInd" value="0" />
                            <label class="form-check-label" for="rdbVentureInd" style="color:#000;">Individual</label>
                        </div>
                    </div>
                    <div class="form-check form-check-inline l-radio left">
                        <div class="panel-container" (click)="selectRadio('rdbVentureId')">
                            <input class="form-check-input" (change)="doChangeVenture(1)" type="radio" name="rdbVenture"
                                id="rdbVentureId" value="0" />
                            <label class="form-check-label" for="rdbVentureId" style="color:#000;">
                                Project / Venture
                                <i class="fa fa-question-circle help-icon opacity"
                                    title="Select Project/Venture if your Property is in a Venture. If you don't find your Venture, add it from Builder/Agent Login in My Posts."></i>
                            </label>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <div class="mrg15T pad10R" *ngIf="postRequest.isVenture">
                        <select *ngIf="ventureList.length != 0" id="txtSelectedVentures"
                            [(ngModel)]="postRequest.ventureId" class="form-control">
                            <option value="">Select</option>
                            <option *ngFor="let venture of ventureList || []" [value]="venture.ProjectID">
                                {{ venture.ProjectOrVentureName }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="Your-Preffered-Location" *ngIf="!isPostEdit">
                    <!-- Buy Section - Multi-select -->
                    <!-- Buy Section - Multi-select -->
                    <div class="form-group location_select" *ngIf="postRequest.requestType == 1">
                        <label style="color: #000;font-weight: 500;">Your Preferred Location <span
                                class="close-instruction">(Click on gray bar to Close)</span></label>
                        <div class="buy-area-multiselect">
                            <button type="button" id="txtSelectedAreasBuy" class="form-control buy-area-toggle"
                                (click)="toggleBuyAreaDropdown($event)">
                                <span>{{ getSelectedBuyAreaText() }}</span>
                                <i class="fas"
                                    [ngClass]="showBuyAreaDropdown ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </button>

                            <div class="buy-area-dropdown" *ngIf="showBuyAreaDropdown"
                                (click)="$event.stopPropagation()">
                                <div class="buy-area-search-wrapper">
                                    <i class="fas fa-search search-icon"></i>
                                    <input type="text" class="form-control buy-area-search" placeholder="Search area"
                                        [(ngModel)]="buyAreaSearchTerm" (input)="onBuyAreaSearchInput()" />
                                    <i class="fas fa-times clear-search" *ngIf="buyAreaSearchTerm"
                                        (click)="clearBuyAreaSearch()"></i>
                                </div>

                                <!-- Loading indicator for areas -->
                                <div *ngIf="isAreasLoading" class="buy-area-empty">
                                    <i class="fas fa-spinner fa-spin"></i> Loading areas...
                                </div>

                                <!-- Regular content when loaded -->
                                <ng-container *ngIf="!isAreasLoading">
                                    <div *ngIf="areasList.length === 0" class="buy-area-empty">
                                        <i class="fas fa-info-circle"></i> No areas available
                                    </div>

                                    <div class="buy-area-options" *ngIf="areasList.length > 0">
                                        <label class="buy-area-option" *ngFor="let area of getFilteredBuyAreas()">
                                            <input type="checkbox" [checked]="isBuyAreaSelected(area.AreaID)"
                                                (change)="onBuyAreaToggle(area.AreaID, $event)" />
                                            <span>{{ area.AreaName }}</span>
                                        </label>
                                        <div *ngIf="getFilteredBuyAreas().length === 0" class="buy-area-empty">
                                            <i class="fas fa-search-minus"></i> No results found for "{{
                                            buyAreaSearchTerm }}"
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Selected Areas Display - Below search -->
                        <div class="selected-location-div mt-2"
                            *ngIf="postRequest.requestType == 1 && postRequest.selectedAreasID && postRequest.selectedAreasID.length > 0">
                            <p *ngFor="let areaId of postRequest.selectedAreasID">
                                {{ getAreaNameById(areaId) }}
                                <span (click)="removeSelectedBuyArea(areaId)"><i class="fas fa-times-circle"></i></span>
                            </p>
                        </div>
                    </div>

                    <div class="form-group location_select" *ngIf="postRequest.requestType > 1">
                        <label style="color: #000; font-weight: 500;">Area / Location</label>

                        <div class="rent-area-multiselect">
                            <button type="button" id="txtSelectedAreasRentSale" class="form-control rent-area-toggle"
                                (click)="toggleRentAreaDropdown($event)">
                                <span>{{ getSelectedRentAreaText() }}</span>
                                <i class="fas"
                                    [ngClass]="showRentAreaDropdown ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </button>

                            <div class="rent-area-dropdown" *ngIf="showRentAreaDropdown"
                                (click)="$event.stopPropagation()">
                                <div class="rent-area-search-wrapper">
                                    <i class="fas fa-search search-icon"></i>
                                    <input type="text" class="form-control rent-area-search" placeholder="Search area"
                                        [(ngModel)]="rentAreaSearchTerm" (input)="onRentAreaSearchInput()" autofocus />
                                    <i class="fas fa-times clear-search" *ngIf="rentAreaSearchTerm"
                                        (click)="clearRentAreaSearch()"></i>
                                </div>

                                <!-- Loading indicator -->
                                <div *ngIf="isAreasLoading" class="rent-area-empty">
                                    <i class="fas fa-spinner fa-spin"></i> Loading areas...
                                </div>

                                <!-- Filtered areas list -->
                                <div class="rent-area-options" *ngIf="areasList.length > 0">
                                    <label class="rent-area-option" *ngFor="let area of getFilteredRentAreas()">
                                        <input type="radio" name="rentAreaRadio"
                                            [checked]="isRentAreaSelected(area.AreaID)"
                                            (change)="onRentAreaSelect(area.AreaID)" />
                                        <span>{{ area.AreaName }}</span>
                                    </label>
                                    <div *ngIf="getFilteredRentAreas().length === 0" class="rent-area-empty">
                                        <i class="fas fa-search-minus"></i> No results found for "{{ rentAreaSearchTerm
                                        }}"
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- REMOVED: Selected Area Display chips for single select -->
                        <!-- The selected area is already shown in the button text, no need for chips -->

                        <div *ngIf="!postRequest.selectedAreasID" class="text-danger mt-1 d-flex align-items-center">
                            <i class="fas fa-exclamation-triangle me-1"></i>
                            <span>Select Area</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="clearfix mrg15B"></div>

    <div class="elevate_cls area_units">
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label style="color: #000 !important; font-weight: 500;">Area Units</label>
                    <select name="txtMeasurement" class="form-control" id="txtUnitID" [(ngModel)]="postRequest.unitID"
                        (change)="doLoadIsTotalItems()">
                        <option value="">Select</option>
                        <option *ngFor="let mesr of MeasureList || []" [value]="mesr.UnitID">{{ mesr.UnitName }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-6">
                <form [formGroup]="propertyPostForm">
                    <div class="form-group">
                        <label for="txtProperty_Measure">Measure:</label>
                        <div class="input-group">
                            <input type="text" id="txtProperty_Measure" class="form-control"
                                formControlName="propertyMeasure" autocomplete="off" maxlength="6" />
                            <div *ngIf="propertyPostForm.controls['propertyMeasure'].touched"
                                class="input-group-append">
                                <span *ngIf="propertyPostForm.controls['propertyMeasure'].valid"
                                    class="input-group-text text-success">
                                    <i class="fas fa-check"></i>
                                </span>
                                <span *ngIf="!propertyPostForm.controls['propertyMeasure'].valid"
                                    class="input-group-text text-danger">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                </form>

            </div>

        </div>
        <div class="row" *ngIf="postRequest.requestType > 1">
            <div class="col-sm-6">
                <div class="form-group">
                    <label style="color: #000;font-weight: 500; margin: 5px 0px;">Price Unit</label>
                    <select name="ddlIsTotal" id="ddlIsTotal" class="form-control" [(ngModel)]="isTotal">
                        <option *ngFor="let total of isTotalItemsList || []" [value]="total.unitValue">
                            {{ total.unitText }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-sm-6">
                <form [formGroup]="propertyPostForm">
                    <!-- Other form controls -->
                    <div class="form-group">
                        <label style="color: #000;font-weight: 500; margin: 5px 0px;">
                            Price
                            <span *ngIf="[17, 20, 21, 22, 23].includes(postRequest.selectedSubProdID)">
                                <ng-container *ngIf="postRequest.selectedSubProdID === 21">(Per day)</ng-container>
                                <ng-container *ngIf="postRequest.selectedSubProdID !== 21">(Monthly)</ng-container>
                            </span>
                        </label>
                        <div class="input-group">
                            <input type="text" class="form-control" id="txtBudget" formControlName="requestBudget"
                                autocomplete="off" />
                            <div *ngIf="propertyPostForm.get('requestBudget')?.touched" class="input-group-append">
                                <span *ngIf="propertyPostForm.get('requestBudget')?.valid"
                                    class="input-group-text text-success">
                                    <i class="fas fa-check"></i>
                                </span>
                                <span *ngIf="!propertyPostForm.get('requestBudget')?.valid"
                                    class="input-group-text text-danger">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>


        <div class="row" *ngIf="postRequest.requestType == 1">
            <div class="col-sm-6">
                <div class="form-group">
                    <label style="color: #000;font-weight: 500; margin: 5px 0px;">Budget Unit</label>
                    <select name="ddlIsTotal" id="ddlIsTotal" class="form-control" [(ngModel)]="isTotal"
                        (ngModelChange)="doLoadIsTotalItems()">
                        <option value="{{total.unitValue}}" *ngFor="let total of isTotalItemsList || []">{{
                            total.unitText
                            }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-sm-6">
                <form [formGroup]="propertyPostForm">
                    <div class="form-group">
                        <label style="color: #000;font-weight: 500;">Budget</label>
                        <div class="input-group">
                            <input type="text" class="form-control" id="txtBudget" formControlName="requestBudget"
                                autocomplete="off" />
                            <div *ngIf="propertyPostForm.get('requestBudget')?.touched" class="input-group-append">
                                <span *ngIf="propertyPostForm.get('requestBudget')?.valid"
                                    class="input-group-text text-success">
                                    <i class="fas fa-check"></i>
                                </span>
                                <span *ngIf="!propertyPostForm.get('requestBudget')?.valid"
                                    class="input-group-text text-danger">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>


        <!--    WHEN REQUESTED PROPEERTY IS RESIDENTIAL     -->
        <ng-container
            *ngIf="postRequest.propertyType == 1 && ![17, 20, 21,22, 23].includes(postRequest.selectedSubProdID)">
            <div class="row">
                <div class="col-sm-6">
                    <form [formGroup]="propertyPostForm">
                        <div class="form-group">
                            <label style="color: #000 !important;font-weight: 500;">No Of Bedrooms</label>
                            <div class="input-group">
                                <input type="text" class="form-control" id="txtBed_Rooms" formControlName="bedRooms"
                                    autocomplete="off" />
                                <div *ngIf="propertyPostForm.get('bedRooms')?.touched" class="input-group-append">
                                    <span *ngIf="propertyPostForm.get('bedRooms')?.valid"
                                        class="input-group-text text-success">
                                        <i class="fas fa-check"></i>
                                    </span>
                                    <span *ngIf="!propertyPostForm.get('bedRooms')?.valid"
                                        class="input-group-text text-danger">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
                <div class="col-sm-6">
                    <form [formGroup]="propertyPostForm">
                        <div class="form-group">
                            <label style="color: #000 !important;font-weight: 500;">No Of Bath Rooms</label>
                            <div class="input-group">
                                <input type="text" class="form-control" id="txtBath_Rooms" formControlName="bathRooms"
                                    autocomplete="off" />
                                <div *ngIf="propertyPostForm.get('bathRooms')?.touched" class="input-group-append">
                                    <span *ngIf="propertyPostForm.get('bathRooms')?.valid"
                                        class="input-group-text text-success">
                                        <i class="fas fa-check"></i>
                                    </span>
                                    <span *ngIf="!propertyPostForm.get('bathRooms')?.valid"
                                        class="input-group-text text-danger">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ng-container>

        <ng-container
            *ngIf="(postRequest.propertyType == 1 || postRequest.propertyType == 2 ) &&  ![17,20,22].includes(postRequest.selectedSubProdID)">
            <div class="row">
                <div class="col-sm-6">
                    <form [formGroup]="propertyPostForm">
                        <div class="form-group">
                            <label style="color: #000 !important;font-weight: 500;">No Of Lifts
                                <span class="help-icon" (click)="toggleHelp('noLift')">
                                    <i class="fas fa-question-circle"></i>
                                </span>
                            </label>
                            <div class="input-group">
                                <input type="text" class="form-control" id="txtNoLift" formControlName="noLift"
                                    autocomplete="off" />
                                <div *ngIf="propertyPostForm.get('noLift')?.touched" class="input-group-append">
                                    <span *ngIf="propertyPostForm.get('noLift')?.valid"
                                        class="input-group-text text-success">
                                        <i class="fas fa-check"></i>
                                    </span>
                                    <span *ngIf="!propertyPostForm.get('noLift')?.valid"
                                        class="input-group-text text-danger">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="showHelp.noLift" class="tool-tip-help-text">
                                Enter 0 if No Lift is available
                            </div>
                        </div>
                    </form>
                </div>

                <div class="col-sm-6">
                    <form [formGroup]="propertyPostForm">
                        <div class="form-group"
                            [ngClass]="{'valid': propertyPostForm.controls.propertyAge.valid, 'invalid': propertyPostForm.controls.propertyAge.invalid}">
                            <label style="color: #000 !important; font-weight: 500;">Property Age
                                <span class="help-icon" (click)="toggleHelp('propertyAge')">
                                    <i class="fas fa-question-circle"></i>
                                </span>
                            </label>
                            <div class="input-group">
                                <input type="text" class="form-control" id="txtProperty_Age"
                                    formControlName="propertyAge" autocomplete="off" />
                                <div class="input-group-append">
                                    <span class="input-group-text" [ngClass]="{
        'bg-danger text-white': propertyPostForm.get('propertyAge')?.invalid && propertyPostForm.get('propertyAge')?.touched
      }">
                                        Months
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="showHelp.propertyAge" class="tool-tip-help-text">
                                For New Property add 0 and Property which is under construction or not started add
                                -1
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ng-container>

        <ng-container
            *ngIf="(postRequest.propertyType == 1 || postRequest.propertyType == 2 ) &&  ![17,20,22].includes(postRequest.selectedSubProdID)">

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group d-flex align-items-center" style="gap: 10px;">
                        <label class="form-label mb-0" style="color: #000; font-weight: 500;">Car Parking:</label>

                        <div class="category-radio-div d-flex" style="gap: 20px;">
                            <div class="form-check form-check-inline l-radio left">
                                <div class="panel-container d-flex align-items-center"
                                    (click)="selectParkingRadio('chkParkingNo')">
                                    <input class="form-check-input" [(ngModel)]="postRequest.isParking"
                                        [ngModelOptions]="{standalone: true}" type="radio" name="chkParking"
                                        id="chkParkingNo" value="0" (change)="doChangePostValue('Parking', '0')" />
                                    <label class="form-check-label ms-1 mb-0" for="chkParkingNo"
                                        style="color:#000;">NO</label>
                                </div>
                            </div>

                            <div class="form-check form-check-inline l-radio left">
                                <div class="panel-container d-flex align-items-center"
                                    (click)="selectParkingRadio('chkParkingYes')">
                                    <input class="form-check-input" [(ngModel)]="postRequest.isParking"
                                        [ngModelOptions]="{standalone: true}" type="radio" name="chkParking"
                                        id="chkParkingYes" value="1" (change)="doChangePostValue('Parking', '1')" />
                                    <label class="form-check-label ms-1 mb-0" for="chkParkingYes"
                                        style="color:#000;">YES</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </ng-container>
    </div>

    <div class="clearfix mrg15B"></div>

    <div class="pad15L">
        <ng-container *ngIf="postRequest.propertyType == 3 ">
            <div class="row elevate_cls_div">
                <div class="col-sm-6" *ngIf="postRequest.requestType != 1">
                    <div class="form-group">
                        <label style="color: #000 !important;font-weight: 500;">Facing</label>
                        <select name="ddlCarParking" id="ddlpropertyFacing" class="form-control"
                            [(ngModel)]="postRequest.propertyFacing" [ngModelOptions]="{standalone: true}">
                            <option value="">Select Land Facing</option>
                            <option value="North">North</option>
                            <option value="South">South</option>
                            <option value="East">East</option>
                            <option value="West">West</option>
                            <option value="North-East">North-East</option>
                            <option value="North-West">North-West</option>
                            <option value="South-East">South-East</option>
                            <option value="South-West">South-West</option>
                            <option value="Corner Plot">Corner Plot</option>
                            <option value="Other Facings">Other Facings</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="postRequest.requestType != 1">
                    <div class="form-group">
                        <label style="color: #000 !important;font-weight: 500;">Permission</label>
                        <select name="ddlPermission" id="ddlPermission" class="form-control"
                            [(ngModel)]="postRequest.layoutAuthority" [ngModelOptions]="{standalone: true}">
                            <option value="">Select Layout</option>
                            <option value="Gram Panchayat">Gram Panchayat</option>
                            <option value="DTCP">DTCP</option>
                            <option value="HMDA">HMDA</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                </div>


                <div class="col-sm-6">
                    <div class="form-group">
                        <label style="color: #000 !important;font-weight: 500;">Road Type</label>
                        <select name="ddlCarParking" id="ddlRoad_Type" class="form-control"
                            [(ngModel)]="postRequest.roadType" [ngModelOptions]="{standalone: true}">
                            <option value="">Select Road Type</option>
                            <option value="Gravel Roads">Gravel Roads</option>
                            <option value="Farm Access Roads">Farm Access Roads</option>
                            <option value="Service Roads">Service Roads</option>
                            <option value="Field Roads">Field Roads</option>
                            <option value="Rural Highways">Rural Highways</option>
                            <option value="Grass or Turf Roads">Grass or Turf Roads</option>
                            <option value="Access Tracks">Access Tracks</option>
                            <option value="Farm-to-Market Roads">Farm-to-Market Roads</option>
                            <option value="Rural Routes">Rural Routes</option>
                            <option value="CC Road">CC Road</option>
                        </select>
                    </div>
                </div>

                <div class="col-sm-6">
                    <form [formGroup]="propertyPostForm">
                        <div class="form-group"
                            [ngClass]="{'valid': propertyPostForm.controls.roadSize.valid, 'invalid': propertyPostForm.controls.roadSize.invalid}">
                            <label style="color: #000 !important;font-weight: 500;">Road Size(SFT)</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="roadSize" autocomplete="off" />
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        SQFT
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="propertyPostForm.controls.roadSize.invalid && (propertyPostForm.controls.roadSize.dirty || propertyPostForm.controls.roadSize.touched)"
                                class="text-danger">
                                Enter number only
                            </div>
                        </div>
                    </form>
                </div>


                <ng-container *ngIf="isAgriculture==true">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label style="color: #000 !important; font-weight: 500;">Soil Type</label>
                            <select name="ddlCarParking" id="ddlsocilType" class="form-control"
                                [(ngModel)]="postRequest.socilType" [ngModelOptions]="{standalone: true}">
                                <option value="">Select Soil Type</option>
                                <option value="Black Soil">Black Soil</option>
                                <option value="Clay Soil">Clay Soil</option>
                                <option value="Red Soil">Red Soil</option>
                                <option value="Sand Soil">Sand Soil</option>
                                <option value="Rocky Soil">Rocky Soil</option>
                                <option value="Acidic Soil">Acidic Soil</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-6" *ngIf="postRequest.requestType != 1">
                        <div class="form-group">
                            <label style="color: #000 !important;font-weight: 500;">Crop</label>
                            <input type="text" class="form-control" id="txtCrop_Plantation"
                                [(ngModel)]="postRequest.cropPlantation" [ngModelOptions]="{standalone: true}"
                                autocomplete="off" />
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label
                                style="color: #000 !important;font-weight: 500; display: block; margin-bottom: 5px;">Fencing</label>
                            <div class="form-check form-check-inline l-checkbox">
                                <input class="form-check-input" [ngModel]="postRequest.isFencing === '1'"
                                    [ngModelOptions]="{standalone: true}" type="checkbox" id="chkFencing"
                                    (change)="doChangePostValue('Fencing', $event.target.checked ? '1' : '0')" />
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label
                                style="color: #000 !important;font-weight: 500; display: block; margin-bottom: 5px;">Electricity</label>
                            <div class="form-check form-check-inline l-checkbox">
                                <input class="form-check-input" [ngModel]="postRequest.isElectricity === '1'"
                                    [ngModelOptions]="{standalone: true}" type="checkbox" id="chkElectricity"
                                    (change)="doChangePostValue('Electricity', $event.target.checked ? '1' : '0')" />
                            </div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="form-group">
                            <label
                                style="color: #000 !important;font-weight: 500; display: block; margin-bottom: 5px;">Water
                                Facility</label>
                            <div class="form-check form-check-inline l-checkbox">
                                <input class="form-check-input" [ngModel]="postRequest.isWaterFacility === '1'"
                                    [ngModelOptions]="{standalone: true}" type="checkbox" id="chkWaterFacility"
                                    (change)="doChangePostValue('WaterFacility', $event.target.checked ? '1' : '0')" />
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div class="col-sm-6">
                    <div class="form-group">
                        <label style="color: #000 !important;font-weight: 500;">Dist NHW (KMs)</label>
                        <input type="text" class="form-control" id="txtDistance_NHW" placeholder="IN KILOMETERS"
                            [(ngModel)]="postRequest.distanceNHW" [ngModelOptions]="{standalone: true}"
                            autocomplete="off" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label style="color: #000 !important;font-weight: 500;">Dist ORR (KMs)</label>
                        <input type="text" class="form-control" placeholder="IN KILOMETERS"
                            [(ngModel)]="postRequest.distanceORR" [ngModelOptions]="{standalone: true}"
                            id="txtDistance_ORR" autocomplete="off" />
                    </div>
                </div>

            </div>

        </ng-container>
    </div>

    <div class="clearfix mrg15B"></div>
    <!-- Replace the existing Amenities section with this improved version -->
    <div class="row" *ngIf="postRequest.requestType > 0 ">
        <div class="col-12">
            <div class="elevate_cls">
                <div class="form-group location_select">
                    <label style="color: #000;font-weight: 500;" for="txtAmenities">Amenities</label>

                    <div class="amenity-multiselect">
                        <button type="button" id="txtAmenities" class="form-control amenity-toggle"
                            (click)="toggleAmenityDropdown($event)">
                            <span>{{ getSelectedAmenityText() }}</span>
                            <i class="fas" [ngClass]="showAmenityDropdown ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        </button>

                        <div class="amenity-dropdown" *ngIf="showAmenityDropdown" (click)="$event.stopPropagation()">
                            <div class="amenity-search-wrapper">
                                <i class="fas fa-search search-icon"></i>
                                <input type="text" class="form-control amenity-search" placeholder="Search amenity"
                                    [(ngModel)]="amenitySearchTerm" (input)="onAmenitySearchInput()" />
                                <i class="fas fa-times clear-search" *ngIf="amenitySearchTerm"
                                    (click)="clearAmenitySearch()"></i>
                            </div>

                            <!-- Loading indicator for amenities -->
                            <div *ngIf="isAmenitiesLoading" class="amenity-empty">
                                <i class="fas fa-spinner fa-spin"></i> Loading amenities...
                            </div>

                            <!-- Regular content when loaded -->
                            <ng-container *ngIf="!isAmenitiesLoading">
                                <div *ngIf="amenitiesList.length === 0" class="amenity-empty">
                                    <i class="fas fa-info-circle"></i> No amenities available
                                </div>

                                <div class="amenity-options" *ngIf="amenitiesList.length > 0">
                                    <label class="amenity-option" *ngFor="let amenity of getFilteredAmenities()">
                                        <input type="checkbox" [checked]="isAmenitySelected(amenity.AmenityID)"
                                            (change)="onAmenityToggle(amenity.AmenityID, $event)" />
                                        <span>{{ amenity.AmenityName }}</span>
                                    </label>
                                    <div *ngIf="getFilteredAmenities().length === 0" class="amenity-empty">
                                        <i class="fas fa-search-minus"></i> No results found for "{{ amenitySearchTerm
                                        }}"
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Selected Amenities Display - Below search with chips -->
                    <div class="selected-location-div mt-2"
                        *ngIf="postRequest.Amenities && postRequest.Amenities.length > 0">
                        <p *ngFor="let amenityId of postRequest.Amenities">
                            {{ getAmenityNameById(amenityId) }}
                            <span (click)="removeSelectedAmenity(amenityId)"><i class="fas fa-times-circle"></i></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="clearfix mrg15B"></div>
    <div class="budget-div Locationdiv" *ngIf="postRequest.requestType > 1">
        <div class="elevate_cls">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-7">
                <label for="rdbReqWant"
                    style="float: left; margin-right: 5px;color: #000;font-weight: 500;margin-top: 10px;">Location:</label>
                <div class="category-radio-div">
                    <div class="form-check form-check-inline l-radio">
                        <div class="panel-container" (click)="selectRadio('rdbSameLocation')">
                            <input class="form-check-input" type="radio" name="rdbPropLocation" id="rdbSameLocation"
                                value="Same" (change)="doChangeLocation(1)" />
                            <label class="form-check-label" for="rdbSameLocation"
                                style="color: #000;font-weight: 500;">Current Location</label>
                        </div>
                    </div>
                    <div class="form-check form-check-inline l-radio">
                        <div class="panel-container" (click)="selectRadio('rdbOtherLocation')">
                            <input class="form-check-input" type="radio" name="rdbPropLocation" id="rdbOtherLocation"
                                value="Other" (change)="doChangeLocation(0)" />
                            <label class="form-check-label" for="rdbOtherLocation"
                                style="color: #000;font-weight: 500;">Other Location</label>
                        </div>
                    </div>
                </div>
                </div>
                <div class="col-sm-5 enable_location">  <div class="input-box">
    <span class="material-icons icon-left v_align">my_location</span>
    <span> Enable location if not enabled in browser </span>
    <button class="material-icons icon-right br0 v_align">location_on</button>
  </div> </div>
</div>
                <div>
                    <!-- Add margin to the textarea -->
                    <textarea class="form-control" id="txtDescription" [(ngModel)]="postRequest.address"
                        (blur)="loadMapBasedOnAddress()" style="margin-bottom: 10px;" readonly="readonly"
                        required></textarea>

                    <!-- Conditionally apply 'hidden' class to the map container -->
                    <div id="map" [ngClass]="{'hidden': !showMap}"
                        style="width: 100%; height: 100px; margin-bottom: 20px;"></div>
                    <!-- Add instructional text below the map with a Google Maps marker icon -->
                    <p *ngIf="showMap" style="font-size: small; color: black;">
                        Drag Location Icon
                        <img src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2_hdpi.png"
                            alt="Google Maps Marker Icon" style="width: 12px; height: 12px; vertical-align: middle;">
                        to your desired place
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="clearfix mrg15B"></div>
    <div class="elevate_cls">

        <div class="budget-div">
            <div class="form-group">
                <label style="color: #000;font-weight: 500;">Description</label>
                <angular-editor class="form-control" id="txtDescription" [placeholder]="'Enter text here...'"
                    [(ngModel)]="postRequest.shortDescription" style="white-space: pre-line;"
                    maxlength="4000"></angular-editor>
            </div>
        </div>
    </div>

    <div class="clearfix mrg15B"></div>

    <div [ngClass]="ViewType == 'Mobile' ? 'post-mobile-pic-div' : 'post-web-pic-div'"
        *ngIf="postRequest.requestType > 1">
        <div class="row">
            <!-- Left: Normal Pics/Videos -->
            <div class="col-md-6">
                <label class="hd_txt">
                    Add Pics (Upto 15) /Video (1 below 20 MB)
                    <span class="help-icon" data-toggle="tooltip" data-placement="top"
                        title="Only 1 Video should be in MP4 format below 20 MB size. If it is more than 20 MB, use external websites like https://www.veed.io/tools/video-compressor to reduce size below 20 MB with 1280 x 720 pixels (720p) and 16:9 aspect ratio">
                        <i class="fas fa-question-circle"></i>
                    </span>
                </label>

                <div class="upload-section d-flex flex-wrap gap-2 mt-2" (drop)="handleDrop($event, 'I')"
                    (dragover)="allowDrop($event)">
                    <!-- Preview thumbnails -->
                    <div class="post-inner-pic-div" *ngFor="let path of imageUpload || []; let i = index">
                        <img *ngIf="!path.isVideo" [src]="path.imgPath" alt="" />
                        <video class="thumbnail custom-video" *ngIf="path.isVideo" controls
                            [src]="path.imgPath"></video>
                        <div class="remove-pic-div" (click)="removeUploadedImg(i, 'I')">
                            <i class="fas fa-trash"></i>
                        </div>
                    </div>

                    <!-- Upload control -->
                    <div class="post-upload-pic-div upload-drop-area" *ngIf="imgIndex < 14 || videoIndex < 2"
                        (click)="doUploadImage()">
                        <i class="drop_img"></i>
                        <div class="drop_txt">Drop or <span class="drop_txt_hi_txt">browse</span></div>
                        <div class="support_txt">Supports: JPG, JPEG2000, PNG, GIF, WEBP, MP4</div>
                        <input type="file" class="form-control" id="propertyFiles" name="propertyFiles"
                            style="display: none;" accept="image/gif, image/png, image/jpeg, video/mp4"
                            (change)="PropertyFiles_change($event)" />
                    </div>
                </div>
            </div>

            <!-- Right: Panorama Pics -->
            <div class="col-md-6">
                <label class="hd_txt">
                    Add Panorama Pics (Upto 3) (1 below 3 MB)
                    <span class="help-icon" data-toggle="tooltip" data-placement="top"
                        title="Only 1 Video should be in MP4 format below 20 MB size. If it is more than 20 MB, use external websites like https://www.veed.io/tools/video-compressor to reduce size below 20 MB with 1280 x 720 pixels (720p) and 16:9 aspect ratio">
                        <i class="fas fa-question-circle"></i>
                    </span>
                </label>

                <div class="upload-section d-flex flex-wrap gap-2 mt-2" (drop)="handleDrop($event, 'P')"
                    (dragover)="allowDrop($event)">
                    <!-- Preview thumbnails -->
                    <div class="post-inner-pic-div" *ngFor="let path of imagePanoromaUpload || []; let i = index">
                        <img *ngIf="!path.isVideo" [src]="path.imgPath" alt="" />
                        <video class="thumbnail custom-video" *ngIf="path.isVideo" controls
                            [src]="path.imgPath"></video>
                        <div class="remove-pic-div" (click)="removeUploadedImg(i, 'P')">
                            <i class="fas fa-trash"></i>
                        </div>
                    </div>

                    <!-- Upload control -->
                    <div class="post-upload-pic-div upload-drop-area" *ngIf="panoramaIndex < 3"
                        (click)="doUploadPanoromaImage()">
                        <i class="drop_img"></i>
                        <div class="drop_txt">Drop or <span class="drop_txt_hi_txt">browse</span></div>
                        <div class="support_txt">Supports: JPG, JPEG, PNG</div>
                        <input type="file" class="form-control" id="propertyPanaromaFiles" name="propertyPanaromaFiles"
                            style="display: none;" accept="image/gif, image/png, image/jpeg, video/mp4"
                            (change)="PropertyPanaromaFiles_change($event)" />
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="budget-div text-center">
        <button type="button" (click)="doPostRequestSubmit()"
            class="btn btn-customer-submit btn-outline-light">Submt</button>
        <br /><br />
    </div>
    <br />
</div>